import styled, { css } from "styled-components";

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : Estilos register
Description : Se definen los estilos de los elementos de la primera parte del formulario de registro.
Date Autor Modification
================================================================================
30/09/2021 Santiago Coca Rojas Creación – Se defienen elementos y estilos del formulario.
================================================================================ */

export const FormGroup = styled.div`
    color: palevioletred;
    width: 300px;
    height: 30px;
    margin: 50px;
    margin-top: 20px;
    @media screen and (max-width: 960px){
        align-content: center;
        margin-top: auto;
    }
`;

export const Form = styled.form`
    width: 400px;
    padding-top: 20px;
    margin: 0px 0px 0px auto;
    border-radius: 8px;
    background-color: white;
    height: 100vh;
    @media screen and (max-width: 960px){
        margin-left: 50px;
    }
`;

export const Button = styled.button`
    margin-bottom: 10px;
`;

export const Label = styled.label`
    display: block;
    margin-top: -5px;
`;

export const Input = styled.input`
	padding: 0.5em;
	width:100%;
    margin-top: -3px;
    margin-bottom: -3px;
`;

export const H2 = styled.h2`
    text-align: center;
    @media screen and (max-width: 960px){
        display: block;
    }
`;

export const Image = styled.img`
    width: 40%;
    margin-top: 0.5em;
`;

export const H3 = styled.h3`
    color: white;

`